import styled from "styled-components";

const CardLogo = styled.img`
  width: auto;
  max-height: 40px;
  max-width: 150px;
`;

export default CardLogo;
